interface LoadRefreshScriptParams {
  refreshUrl: string;
  tokenRefreshScriptUrl: string;
  sriHash: string;
}

export const loadRefreshScript = ({
  refreshUrl,
  tokenRefreshScriptUrl,
  sriHash,
}: LoadRefreshScriptParams) => {
  window.authConfig = {
    endpointUrl: refreshUrl,
  };

  const { head } = document;
  const exists = head?.querySelector(
    `script[src='${tokenRefreshScriptUrl}'][crossorigin='anonymous'][integrity='${sriHash}']`,
  );

  if (!exists) {
    let el = document.createElement('script');
    el.async = true;
    el.src = tokenRefreshScriptUrl;
    el.setAttribute('crossorigin', 'anonymous');
    el.setAttribute('integrity', sriHash);
    head.appendChild(el);
  }
};
